import { get, post, put } from "../Config";
import axios from "axios";
import { baseUrl, headers } from "../Config";
import helper from "services/helper";

export function SearchBroadcast({ params }) {
  return get({ url: `/api/hu/v1/broadcast`, params });
}

// Upload File via API (แทน S3)
export function UploadFile({ file, onProgress }) {
  const formData = new FormData();
  formData.append("myUploadedFile", file);

  return axios({
    url: "/api/hu/v1/file/upload",
    method: "post",
    baseURL: baseUrl,
    headers: {
      ...headers,
      authorization: helper.Auth.getToken(),
      lang: helper.Auth.getLang(),
      "Content-Type": "multipart/form-data",
    },
    data: formData,
    timeout: 120000, // 2 minutes timeout for large files
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percentCompleted);
      }
    },
  });
}
export function GetBroadcastById({ id }) {
  return get({ url: `/api/hu/v1/broadcast/${id}` });
}
export function CreateBroadcast({ params, data }) {
  return post({ url: `/api/hu/v1/broadcast/create`, params, data });
}
export function UpdateBroadcast({ params, data }) {
  return post({ url: `/api/hu/v1/broadcast/update`, params, data });
}
export function DeleteBroadcast({ params, data }) {
  return post({ url: `/api/hu/v1/broadcast/delete`, params, data });
}
export function InputformBroadcast({ params }) {
  return get({ url: `/api/hu/v1/inputform/broadcast`, params });
}
